import { v4 as uuidv4 } from 'uuid';
import { normalizeStoredImageItem, revokeLocalImageUrl } from './localImage.js';
import { LOCAL_ASSET } from './localAssets.js';
import { getQiniuSignedUrl } from './qiniuMedia.js';

export const HEADER_IP_BRAND_COMPONENT_TYPE = 'header-ip-brand';
export const HEADER_IP_BRAND_MODULE_TYPE = 'ipBrand';

export const HEADER_IP_BRAND_DEFAULT_HEIGHT = 300;
export const HEADER_IP_BRAND_DEFAULT_BORDER_RADIUS = 12;

const DEFAULT_BADGE = '个人IP · 私域主页';
const DEFAULT_TITLE = '把你的专业\n做成个人品牌';
const DEFAULT_SUBTITLE = '用内容建立信任，让用户持续沉淀';
const DEFAULT_TAG = 'IP主理人';
const DEFAULT_BADGE_COLOR = '#ffffff';
const DEFAULT_TITLE_COLOR = '#ffffff';
const DEFAULT_SUBTITLE_COLOR = '#e8f1ff';
const DEFAULT_FEATURE_COLOR = '#ffffff';
const DEFAULT_TAG_COLOR = '#ffffff';
const DEFAULT_FEATURE_ICON_COLOR = '#325fb2';
const DEFAULT_BADGE_TAG_BG_COLOR = '#325fb2';

const DEFAULT_FEATURES = [
	{ icon: 'mbm-fensi1', label: '内容展示' },
	{ icon: 'mbm-neirong', label: '粉丝沉淀' },
	{ icon: 'mbm-a-7zengsu', label: '服务成交' },
	{ icon: 'mbm-shopping-bag-fill', label: '长期经营' },
];

function createDefaultBgImage() {
	return {
		id: `header-ip-brand-bg-${uuidv4()}`,
		filename: 'header-ip-brand.png',
		previewUrl: LOCAL_ASSET.headerIpBrand,
		url: '',
		local: false,
	};
}

export function getHeaderIpBrandImageUrl(image) {
	if (!image) return '';
	return getQiniuSignedUrl(image.previewUrl || image.url || '');
}

export function getHeaderIpBrandDefaults() {
	return normalizeHeaderIpBrandData({});
}

export function isHeaderIpBrandComponent(type) {
	return type === HEADER_IP_BRAND_COMPONENT_TYPE;
}

function normalizeBgImage(image) {
	if (!image?.previewUrl && !image?.url) {
		return createDefaultBgImage();
	}
	return normalizeStoredImageItem(image, createDefaultBgImage());
}

function normalizeFeature(item = {}, index = 0) {
	const fallback = DEFAULT_FEATURES[index] || DEFAULT_FEATURES[0];
	const icon = typeof item.icon === 'string' && item.icon.trim()
		? item.icon.trim().replace(/^mbm-iconfont\s+/, '')
		: fallback.icon;
	return {
		id: item.id || `header-ip-brand-feature-${uuidv4()}`,
		icon: icon.startsWith('mbm-') ? icon : `mbm-${icon}`,
		label: typeof item.label === 'string' ? item.label : fallback.label,
	};
}

function normalizeFeatures(list) {
	const source = Array.isArray(list) && list.length
		? list.slice(0, DEFAULT_FEATURES.length)
		: DEFAULT_FEATURES;
	while (source.length < DEFAULT_FEATURES.length) {
		source.push(DEFAULT_FEATURES[source.length]);
	}
	return source.map((item, index) => normalizeFeature(item, index));
}

export function normalizeHeaderIpBrandData(data = {}) {
	return {
		badge: typeof data.badge === 'string' ? data.badge : DEFAULT_BADGE,
		title: typeof data.title === 'string' ? data.title : DEFAULT_TITLE,
		subtitle: typeof data.subtitle === 'string' ? data.subtitle : DEFAULT_SUBTITLE,
		tag: typeof data.tag === 'string' ? data.tag : DEFAULT_TAG,
		showBadge: data.showBadge !== false,
		showTag: data.showTag !== false,
		showFeatures: data.showFeatures !== false,
		textColor: typeof data.textColor === 'string' ? data.textColor : DEFAULT_BADGE_COLOR,
		titleColor: typeof data.titleColor === 'string' ? data.titleColor : DEFAULT_TITLE_COLOR,
		subtitleColor: typeof data.subtitleColor === 'string' ? data.subtitleColor : DEFAULT_SUBTITLE_COLOR,
		badgeColor: typeof data.textColor === 'string' ? data.textColor : DEFAULT_BADGE_COLOR,
		featureColor: typeof data.textColor === 'string' ? data.textColor : DEFAULT_FEATURE_COLOR,
		tagColor: typeof data.textColor === 'string' ? data.textColor : DEFAULT_TAG_COLOR,
		featureIconColor: typeof data.featureIconColor === 'string' ? data.featureIconColor : DEFAULT_FEATURE_ICON_COLOR,
		badgeTagBgColor: typeof data.badgeTagBgColor === 'string' ? data.badgeTagBgColor : DEFAULT_BADGE_TAG_BG_COLOR,
		height: HEADER_IP_BRAND_DEFAULT_HEIGHT,
		borderRadius: (() => {
			if (data.borderRadius === 0 || data.borderRadius === '0') return 0;
			const raw = Number(data.borderRadius);
			if (Number.isFinite(raw)) return Math.max(0, raw);
			return HEADER_IP_BRAND_DEFAULT_BORDER_RADIUS;
		})(),
		image: normalizeBgImage(data.image),
		features: normalizeFeatures(data.features),
		jumpLink: data?.jumpLink?.type ? { ...data.jumpLink } : null,
	};
}

export function revokeHeaderIpBrandImages(data) {
	revokeLocalImageUrl(data?.image?.previewUrl);
}
